import { defineMessages } from 'react-intl';

export default defineMessages({
    entryPopupTitle: {
        id: 'ml.quoteandbind.esignature.You\'re almost done',
        defaultMessage: 'You\'re almost done'
    },
    continue: {
        id: 'ml.quoteandbind.esignature.continue',
        defaultMessage: 'Continue'
    },
    exitPopupTitle: {
        id: 'ml.quoteandbind.esignature.Finish later...',
        defaultMessage: 'Finish later...'
    },
    exitPopupSubtitle: {
        id: 'ml.quoteandbind.esignature.Finish review and sign documents later',
        defaultMessage: 'You can finish reviewing and sign your documents later'
    },
    finishLater: {
        id: 'ml.quoteandbind.esignature.Finish Later',
        defaultMessage: 'Finish Later'
    },
    cancel: {
        id: 'ml.quoteandbind.esignature.cancel',
        defaultMessage: 'Cancel'
    },
    loading: {
        id: 'ml.quoteandbind.esignature.loading',
        defaultMessage: 'Loading...'
    },
    additionalRequiredSignatures: {
        id: 'ml.quoteandbind.esignature.Additional required signatures',
        defaultMessage: 'Your policy will automatically be issued after the additional required signatures have been completed.  The additional signers have been sent an email to complete the signature process.  Once signatures are completed, watch for your Welcome email and be sure to register your account.'
    },
    signAndFinishPolicy: {
        id: 'ml.quoteandbind.esignature.Sign and finish policy',
        defaultMessage: 'Click {continue} to sign and finish your policy.'
    },
    processingPayment: {
        id: 'ml.quoteandbind.esignature.Processing Payment...',
        defaultMessage: 'Processing Payment...'
    },
});
